module.exports = __webpack_public_path__ + "static/media/16.45476e2d.mp3";